module.exports = __webpack_public_path__ + "img/educationalTraining6.e794be66.png";